export default "__VITE_ASSET__243ba451__"